import CartIconButton from 'comps/CartIconButton';
import Dp from 'icons/std/dp.svg';
import { SiteContext, UserContext } from 'libs/contexts';
import { SITE_MODE, USER_AUTHRIZED_STATUS } from 'libs/enums';
import React, { Fragment, useContext } from 'react';
import Button from './Button';
import { USER_TYPE, isCurrentUserType } from '@/libs/user';

function ProductDetailAddToCartBar(
  {
    disabled,
    onClickAdd,
    onClickBuy,
    onClickShop,
    btnTxt,
    tradeAgreementArr,
  }: {
    disabled: boolean;
    onClickShop: () => void;
    btnTxt: string;
    onClickBuy: () => void;
    onClickAdd: () => void;
    tradeAgreementArr: any[];
  },
  ref,
) {
  // const { showPrice } = useContext(PriceContext)
  const userInfo = useContext(UserContext);
  const site = useContext(SiteContext);

  const canBuy = () => {
    const isAuthrizedPurcharser =
      userInfo &&
      userInfo.isPurchaser &&
      [USER_AUTHRIZED_STATUS.AUDIT_PURCHASE, USER_AUTHRIZED_STATUS.AUDIT_BOTH].includes(
        userInfo.orgAuditType,
      );
    if (!isAuthrizedPurcharser) return false;
    const hasGerneralAgreement = tradeAgreementArr.filter(
      (item) => !item.tradeAgreementScope,
    ).length;
    const hasSpecificAgreement = tradeAgreementArr.filter(
      (item) => !!item.tradeAgreementScope,
    ).length;
    // 外部采购商
    if (!userInfo.isInside) {
      return isAuthrizedPurcharser && Boolean(hasGerneralAgreement || hasSpecificAgreement);
    }
    // 内部认证采购商
    if (userInfo.isInside) {
      return isAuthrizedPurcharser && hasSpecificAgreement;
    }
    return false;
  };
  const isCantBuyUserType =
    //   TODO 20231220 判断当前用户身份 采购、供应、运营、个人
    isCurrentUserType(userInfo, USER_TYPE.SUPPLIER) ||
    isCurrentUserType(userInfo, USER_TYPE.SUPPLIER_PARTNER) ||
    isCurrentUserType(userInfo, USER_TYPE.SUPPLY_CHAIN) ||
    isCurrentUserType(userInfo, USER_TYPE.OPERATIONS_MANAGEMENT);
  return (
    <>
      <div className="addToCartRow">
        <div className="icons">
          {site?.mall?.enableSelfSiteMode === SITE_MODE.SHOP && (
            <div className="shopIcon">
              <a onClick={onClickShop}>
                <div>
                  <Dp />
                </div>
                <span className="shopIconTxt">店铺</span>
              </a>
            </div>
          )}
          {!isCantBuyUserType && (
            <div ref={ref} className="shopIcon">
              <CartIconButton />
            </div>
          )}
        </div>
        {disabled ? (
          <Button
            text={btnTxt}
            type="primary"
            style={{
              padding: 0,
            }}
            disabled
          />
        ) : (
          <Fragment>
            <Button
              text="立即购买"
              type="secondary"
              style={{
                marginRight: '12px',
                boxShadow: 'none',
                padding: 0,
              }}
              // 不展示价格并且有用户信息，说明当前是仅供应商身份导致价格不可见，这个时候按钮要禁用
              disabled={!canBuy() || isCantBuyUserType}
              onClick={onClickBuy}
            />
            <Button
              text="加入购物车"
              type="primary"
              style={{
                padding: 0,
              }}
              // 不展示价格并且有用户信息，说明当前是仅供应商身份导致价格不可见，这个时候按钮要禁用
              disabled={!canBuy() || isCantBuyUserType}
              onClick={onClickAdd}
            />
          </Fragment>
        )}
      </div>
      <style jsx>{`
        .addToCartRow {
          padding: 6px 16px 6px 0;
          padding-left: 0;
          background-color: #fff;
          display: flex;
          align-items: center;
          padding-bottom: max(constant(safe-area-inset-bottom, 6px), 6px);
          padding-bottom: max(env(safe-area-inset-bottom, 6px), 6px);
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 10;
        }

        .addToCartRow .icons {
          flex: 0 0 100px;
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          font-size: 0;
        }

        .shopIcon :global(a) {
          font-size: 0;
          color: #666666;
          font-weight: 400;
          width: 40px;
          height: 34px;
          position: relative;
          display: block;
          text-align: center;
        }

        .shopIcon :global(svg) {
          width: 22px;
          height: 19px;
        }

        .shopIcon :global(.cartBtn) {
          width: 36px;
          height: 19px;
        }

        .shopIcon :global(.cartBtn svg) {
          width: 32px;
          height: 20px;
        }

        .shopIcon :global(span) {
          font-size: 12px;
          color: #666666;
          margin-top: 2px;
          width: 38px;
          text-align: center;
          transform: scale(0.83);
          display: inline-block;
          white-space: nowrap;
        }

        .shopIcon :global(.rv-badge--fixed) {
          transform: scale(0.83);
        }

        .cart .noProduct {
          margin-bottom: 17px;
        }
      `}</style>
    </>
  );
}

export default React.forwardRef(ProductDetailAddToCartBar);
